import { create } from 'zustand';

export type ChatState = {
  unreadCount: number;
  setUnreadCount: (count: number) => void;
  incrementUnread: () => void;
  resetUnread: () => void;
  decrementUnread: (count: number) => void;
};

export const useChatStore = create<ChatState>((set) => ({
  unreadCount: 0,
  setUnreadCount: (count) => set({ unreadCount: Math.max(0, count) }),
  incrementUnread: () => set((state) => ({ unreadCount: state.unreadCount + 1 })),
  resetUnread: () => set({ unreadCount: 0 }),
  decrementUnread: (count) => set((state) => ({ unreadCount: Math.max(0, state.unreadCount - count) })),
}));
